import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { PaymentList } from '@C/CreditCustomerProfile/Payments';
import ErrorBoundary from '@C/Error';

class PaymentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Create dealer" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <PaymentList />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { PaymentsPage };
